<template>
	<div v-show="userPermissionsFilter.viewusers" :class="[companyClass, canScroll]">
		<div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<h2 class="text-white">Operational Countries</h2>
			<div class="table-responsive">
				<table class="table" id="datatable" style="color:white;">
					<thead>
						<tr>
							<th>Country Name</th>
							<th>Capital</th>
							<th>Code</th>
							<th>Banks</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in companycountries" :key="item.userID">
							<td>{{ item.name }}</td>
							<td>{{ item.capital }}</td>
							<td>{{ item.code }}</td>
							<td><a :href="'countrybankslist/' + item.id"><i class="mdi mdi-eye"></i></a></td>
						</tr>
					</tbody>
					<tfoot>
						<tr>
							<th>Country Name</th>
							<th>Capital</th>
							<th>Code</th>
							<th>Banks</th>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'countrybanks',
	data: function () {
		return {
			companyRegions: [],
			companycountries: []
		}
	},
	computed: {
	},
	methods: {
		print(row) {
			router.push(`/usertransactions/${row.userID}`);
		},
		async initializeData() {
			await this.getOperationalCountries();
			this.companycountries = this.companyRegions;
			console.log(this.companycountries);
			this.$nextTick(function () {
				this.initDt()
			});
		},
		initDt() {
			var cmp = this.loggedInCompany.name + " Transactions";
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				retrieve: true,
				dom: 'Blfrtip',
				"aaSorting": [],
				buttons: [
					'print'
				],
			});
		}
	},
	mounted() {
		//API Call

	},
	created() {
		this.initializeData();
	},
	mixins: [PermissionsMixins]
}

</script>

<style>
table.dataTable tbody tr {
	background-color: #191d24;
}

table.dataTable {
	margin-left: 0px;
	text-align: left;
}

.avatar-box {
	background: #3773e2;
	margin-bottom: 50px;
	position: relative;
}

.avatar-box img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	position: relative;
	bottom: -50px;
	display: block;
	margin: 0 auto;
	background: white;
	border: 2px solid #3773e2;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
	color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
	color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
	color: white !important;
}
</style>